export const ALLOWED_SET_PROPERTIES = [
  'label',
  'placeholder',
  'required',
] as const;

export const EQUALS = 'equals';
export const DOES_NOT_EQUAL = 'doesNotEqual';
export const GREATER_THAN = 'greaterThan';
export const GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual';
export const LESS_THAN = 'lessThan';
export const LESS_THAN_OR_EQUAL = 'lessThanOrEqual';
export const CONTAINS = 'contains';
export const DOES_NOT_CONTAIN = 'doesNotContain';
export const BEGINS_WITH = 'beginsWith';
export const ENDS_WITH = 'endsWith';
export const IS_EMPTY = 'isEmpty';
export const IS_NOT_EMPTY = 'isNotEmpty';
export const IS_CHANGED = 'isChanged';
export const INCLUDES = 'includes';
export const DOES_NOT_INCLUDE = 'doesNotInclude';

export const MAX_LOGIC_LIMIT = 60;
export const MAX_FIELDS_PER_OUTCOMES_LIMIT = 60;
export const MAX_FIELDS_IN_LOGIC_LIMIT = 120;

export type OperatorType =
  | typeof EQUALS
  | typeof DOES_NOT_EQUAL
  | typeof GREATER_THAN
  | typeof GREATER_THAN_OR_EQUAL
  | typeof LESS_THAN
  | typeof LESS_THAN_OR_EQUAL
  | typeof CONTAINS
  | typeof DOES_NOT_CONTAIN
  | typeof BEGINS_WITH
  | typeof ENDS_WITH
  | typeof IS_EMPTY
  | typeof IS_NOT_EMPTY
  | typeof IS_CHANGED
  | typeof INCLUDES
  | typeof DOES_NOT_INCLUDE;

export const Operators = {
  EQUALS,
  DOES_NOT_EQUAL,
  GREATER_THAN,
  GREATER_THAN_OR_EQUAL,
  LESS_THAN,
  LESS_THAN_OR_EQUAL,
  CONTAINS,
  DOES_NOT_CONTAIN,
  BEGINS_WITH,
  ENDS_WITH,
  IS_EMPTY,
  IS_NOT_EMPTY,
  IS_CHANGED,
  INCLUDES,
  DOES_NOT_INCLUDE,
} as const;

export const OperatorsRequiringValue: Array<string> = [
  Operators.EQUALS,
  Operators.DOES_NOT_EQUAL,
  Operators.GREATER_THAN,
  Operators.GREATER_THAN_OR_EQUAL,
  Operators.LESS_THAN,
  Operators.LESS_THAN_OR_EQUAL,
  Operators.CONTAINS,
  Operators.DOES_NOT_CONTAIN,
  Operators.BEGINS_WITH,
  Operators.ENDS_WITH,
  Operators.INCLUDES,
  Operators.DOES_NOT_INCLUDE,
];

export const SET_INITIAL_LOGICS = 'SET_INITIAL_LOGICS';
export const SET_FORM_FIELDS = 'SET_FORM_FIELDS';
export const ADD_LOGIC = 'ADD_LOGIC';
export const DELETE_LOGIC_ITEM = 'DELETE_LOGIC_ITEM';
export const SET_SELECTED_LOGIC_ID = 'SET_SELECTED_LOGIC_ID';
export const SET_SELECTED_LOGIC = 'SET_SELECTED_LOGIC';
export const UPDATE_MATCH_CONDITIONS = 'UPDATE_MATCH_CONDITIONS';
export const ADD_CONDITION = 'ADD_CONDITION';
export const DELETE_CONDITION = 'DELETE_CONDITION';
export const UPDATE_CONDITION = 'UPDATE_CONDITION';
export const ADD_OUTCOME = 'ADD_OUTCOME';
export const DELETE_OUTCOME = 'DELETE_OUTCOME';
export const ADD_ACTION = 'ADD_ACTION';
export const UPDATE_ACTION = 'UPDATE_ACTION';
export const DELETE_ACTION = 'DELETE_ACTION';

// Action categories
export const ACTIONS = 'actions';
export const ELSE_ACTIONS = 'elseActions';

export type ActionCategory = typeof ACTIONS | typeof ELSE_ACTIONS;

// Action button definitions
export const ACTION_TYPE_SHOW_HIDE = 'showHide';
export const ACTION_TYPE_ENABLE_DISABLE = 'enableDisable';
export const ACTION_TYPE_SET_VALUE = 'setValue';
export const ACTION_TYPE_VALIDATE = 'validate';
export const ACTION_TYPE_SET_PROPERTY = 'setProperty';

export const ActionTypes = {
  SHOW_HIDE: ACTION_TYPE_SHOW_HIDE,
  ENABLE_DISABLE: ACTION_TYPE_ENABLE_DISABLE,
  SET_VALUE: ACTION_TYPE_SET_VALUE,
  VALIDATE: ACTION_TYPE_VALIDATE,
  SET_PROPERTY: ACTION_TYPE_SET_PROPERTY,
} as const;

export type ActionType = (typeof ActionTypes)[keyof typeof ActionTypes];

export const FIELD_ERROR_MESSAGE = 'fieldErrMessage';
export const OPERATOR_ERROR_MESSAGE = 'operatorErrMessage';
export const VALUE_ERROR_MESSAGE = 'valueErrMessage';

export const ConditionErrorMessages = [
  FIELD_ERROR_MESSAGE,
  OPERATOR_ERROR_MESSAGE,
  VALUE_ERROR_MESSAGE,
] as const;

export type ConditionErrorMessageType = {
  fieldErrMessage?: string | null;
  operatorErrMessage?: string | null;
  valueErrMessage?: string | null;
};

export type ActionErrorMessageType = {
  fieldErrMessage?: string | null;
};
